export var ETranslationLocale;
(function (ETranslationLocale) {
    ETranslationLocale["du"] = "du";
    ETranslationLocale["eng"] = "eng";
    ETranslationLocale["fr"] = "fr";
})(ETranslationLocale || (ETranslationLocale = {}));
